
import 'bootstrap/dist/css/bootstrap.min.css'

// O e-mail de convite/recuperação do Netlify Identity manda a pessoa pra raiz
// do site (com o token na URL) em vez de pro /admin, que é onde o Decap CMS
// (a única coisa que sabe processar esse token) está carregado. Redireciona
// preservando o token, seja como hash (#recovery_token=...) ou query
// (?recovery_token=...), pro Decap conseguir tratar.
const IDENTITY_TOKEN_PARAMS = [
  'invite_token',
  'recovery_token',
  'confirmation_token',
  'email_change_token',
]

export const onClientEntry = () => {
  if (typeof window === 'undefined') return
  if (window.location.pathname.startsWith('/admin')) return

  const hash = window.location.hash.replace(/^#/, '')
  const search = window.location.search.replace(/^\?/, '')
  const tokenParams = hash && IDENTITY_TOKEN_PARAMS.some(p => hash.startsWith(p + '='))
    ? hash
    : search && IDENTITY_TOKEN_PARAMS.some(p => search.startsWith(p + '='))
      ? search
      : null

  if (tokenParams) {
    window.location.replace('/admin/#' + tokenParams)
  }
}